import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import SocialLinks from "./social_links";

class ProfileEditSf extends Component  {
  constructor(props) {
    super(props);

    this.state = {
      isSocialModalShow: false
    };
  }

  handleClick = () => {
    this.setState(prevState => (
      { isSocialModalShow: !prevState.isSocialModalShow }
    ));
  };

  render () {
    const { isSocialModalShow } = this.state;
    const { is_mypage, handleEditButtonClick } = this.props;

    return is_mypage === true && (
      <div className='d-md-none my-3'>
        <button type='button' className='btn btn-outline-primary btn-sm mr-2' data-ga-label='btn-message-head' onClick={handleEditButtonClick}>
          編集
        </button>

        <button type='button' className='btn btn-outline-primary btn-sm' data-ga-label='btn-message-head' onClick={this.handleClick}>
          SNS連携
        </button>

        <Modal isOpen={isSocialModalShow} toggle={this.handleClick}>
          <ModalHeader toggle={this.handleClick}>ソーシャル</ModalHeader>
          <ModalBody>
            <SocialLinks {...this.props} />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

ProfileEditSf.propTypes = {
  is_mypage: PropTypes.bool.isRequired,
  handleEditButtonClick: PropTypes.func
};

ProfileEditSf.defaultProps = {
  handleEditButtonClick: null
};

export default ProfileEditSf;
